<svg
  class="block size-full"
  [attr.width]="width ?? size"
  [attr.height]="height ?? size"
  fill="none"
  preserveAspectRatio="none"
  viewBox="0 0 24 24"
>
  <g id="search-md">
    <path
      d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
      id="Icon"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    ></path>
  </g>
</svg>
